import PropTypes from 'prop-types';
import './SortHead.css';

// Sortable Ledger column header. Lives inside the <th>, inheriting its
// mono/uppercase head type; shows a neutral ⇅ glyph when idle and a blue ↑/↓
// on the active key. sort affordance for every Ledger-based table —
// the parent owns the { activeKey, dir } state and re-queries on `onSort`.
export function SortHead({ label, sortKey, activeKey, dir = 'asc', onSort }) {
  const active = activeKey === sortKey;
  return (
    <button
      type="button"
      className={`ledger-sort-head${active ? ' is-active' : ''}`}
      onClick={() => onSort && onSort(sortKey)}
      aria-label={`${typeof label === 'string' ? label : ''}, ordenar ${
        active && dir === 'asc' ? 'descendente' : 'ascendente'
      }`}
      title={
        active ? (dir === 'asc' ? 'Ascendente' : 'Descendente') : 'Ordenar'
      }
    >
      {label}
      <span className="ledger-sort-arrow" aria-hidden="true">
        {active ? (dir === 'asc' ? '↑' : '↓') : '⇅'}
      </span>
    </button>
  );
}

SortHead.propTypes = {
  label: PropTypes.node.isRequired,
  sortKey: PropTypes.string.isRequired,
  activeKey: PropTypes.string,
  dir: PropTypes.oneOf(['asc', 'desc']),
  onSort: PropTypes.func,
};

export default SortHead;
